import { Outlet } from 'react-router';
import { useBreadcrumb } from '~/components/layout/Breadcrumb';

export default function UploadLithostratTypesBreadcrumbRoute() {
  useBreadcrumb('routes/upload/lithostrat-type', 'Lithostrat Types');
  return <Outlet />;
}
